import { Button } from '@/components/design-system/Button';
import { NotificationsDropdown } from '@/features/notifications/components/NotificationsDropdown';
import { QuestionCircleOutlined, ReadOutlined } from '@ant-design/icons';

export const Actions: React.FC = () => {
  const actions = [
    {
      type: 'help',
      icon: QuestionCircleOutlined,
      onClick: () => undefined
    },
    {
      type: 'documentation',
      icon: ReadOutlined,
      onClick: () => undefined
    }
  ];

  return (
    <div className="text-typography/85 flex items-center gap-2 px-3">
      <NotificationsDropdown />
      {actions.map(({ type, icon: Icon, onClick }) => (
        <Button
          key={type}
          variant="icon"
          className="text-md hover:bg-secondary-400 flex h-8 w-8 items-center justify-center rounded-full p-5"
          onClick={onClick}
        >
          <Icon className="h-4 w-4" />
        </Button>
      ))}
    </div>
  );
};
